import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const AccomendationDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Accomendation Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Accommodation Name</th>
                  <th>Room</th>
                  <th>Bed</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Remarks</th>
                  {/* <th>Document Image</th> */}
                </tr>
              </thead>
              <tbody>
                {employee?.accommodationDetail?.map((a) => (
                  <tr key={a.code}>
                    <td>{a.accommodationName}</td>
                    <td>{a.room}</td>
                    <td>{a.bed}</td>
                    <td>{a.startDate && format(new Date(a.startDate), "yyyy-MM-dd")}</td>
                    <td>{a.endDate && format(new Date(a.endDate), "yyyy-MM-dd")}</td>
                    <td>{a.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

AccomendationDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default AccomendationDetails;
